<template>
  <v-container fluid class="pa-0">
    <DialogSelectBalance ref="dialogSelectBalance"></DialogSelectBalance>
    <DialogDoExport ref='dlgDoExport'></DialogDoExport>
    <SearchRulesManager ref="searchRulesManager" :hitlistMode="hitlistMode" :showManager="showSearch"></SearchRulesManager>
    <v-layout column fluid>
      <v-flex v-if="showHitlist" style="padding: 0px; margin: 0px;">
        <v-card flat style="padding: 0px; margin: 0px;">
          <v-card-text style="padding: 0px; margin: 0px;">
            <FixedTableIE :widthSub="0" :heightSub="55" :heightCRSSub="0" :containerHeight="innerHeight" :ankerBank="bankAnchor" ref="sdTable"
                          :currency="currentCurrency"
                          configSuffix="hitlistankerSearch" tableName=""
                          configChangeEventName="HitlistConfigChange"
                          :hitlistConfigurations="hitlistConfigurations"
                          :headerConfigName="'Anker'"
                          :selected="selected"
                          :sortDisabled="1"
                          :tableConfig='tableConfig' :tableNotComplete="tableNotComplete"
                          :headers="headers" :items="pgresults" class="colorrows"></FixedTableIE>
            <div v-if="((pgresults === null))"
                class="font-weight-bold bluetext textleft missingDataInPeergroup">{{'TITLE_PEERGROUP_SELECT_FILTERS' |
              translate}}
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn v-if="canExport" outline class="text-none" color="#004884" @click="doExport()" small>
              {{ 'BUTT_SUBMIT_EXCEL' | translate}}
            </v-btn>
            <v-spacer></v-spacer>
            <HitlistPager pageChangeEventName="PageChange"></HitlistPager>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import Vue from 'vue';
  import SearchRulesManager from './mask/SearchRulesManager';
  import FixedTableIE from './../tables/EasyTableIE'
  import HitlistPager from '../widgets/HitlistPager';
  import DialogSelectBalance from './dialogs/DialogSelectBalance'
  import DialogDoExport from './dialogs/DialogDoExport'

  export default {
    name: 'Suche.vue',
    components: { HitlistPager, SearchRulesManager, FixedTableIE, DialogSelectBalance, DialogDoExport },
    data() {
      return {
        currentSearchData: null,
        reqHistlist: { state: null },
        pageCache: [],
        canExport: false,
        orderCellName: null,
        link: '',
        currentItem: null,
        first: true,
        firstOrderBy: '',
        currentCrefoNr: -1,
        myData: null,
        tableNotComplete: false,
        headers: [],
        pgresults: [],
        currentCurrency: '1',
        bankAnchor: null,
        selected: false,
        headerFields: [],
        idModule: '',
        idModuleItem: '',
        'tableConfig': {
          selection: false,
          isClickable: true,
          header: {
            columnClass: 'verlauf abstandunten04 theme--light blue tableIEPadding1 headcolumn'
          },
          rows: {
            rowClass: 'rowEIE'
          },
        },
        showHitlist: true,
        showSearch: false,
        currentSearchItem: null,
        currentItemData: {},
        currentRule: 0,
        currentSearchArea: null,
        formula: '',
        labels: {
          from: Vue.i18n.translate('LABEL_SITEM_FROM'),
          to: Vue.i18n.translate('LABEL_SITEM_TO'),
          latitude: Vue.i18n.translate('LABEL_SITEM_LAT'),
          longitude: Vue.i18n.translate('LABEL_SITEM_LONG'),
          radius: Vue.i18n.translate('LABEL_SITEM_RADIUS'),
          currencydimension: Vue.i18n.translate('CURRENCY_DIMENSION'),
          actionButton: '',
        },
        maskedInput: false,
        maskedScale: '',
        currencyDimensions: [],
        suffix: '',
        innerHeight: 400,
        filterRules: [],
        totalHits: '',
        hitlistMode: "companies",
        hitlistConfigurations: [],
        //staticSearchListMode: true,
      }
    },
    methods: {
      setSearchMode: function (newMode) {
        this.showHitlist = !newMode;
        this.showSearch = newMode;

        this.$nextTick(function () {
          window.dispatchEvent(new Event('resize'));
        });
      },
      onResize: function (event) {
        const view = Vue.prototype.$api.viewport();
        const footerHeight = 36;
        const headerHeight = 60;
        const searchItemTitleHeight = 30 + 16;

        const filtersetHeight = this.$refs.searchRulesManager.$el.clientHeight;

        let h2 = view.height - footerHeight - headerHeight - filtersetHeight - searchItemTitleHeight;
        this.innerHeight = h2;

      },
      onSearchRulesManagerAction: function (newMode, data) {
        if (newMode) {
          this.setSearchMode(true);
          // data???
        }
        else {
          this.setSearchMode(false);
          this.submitSearch(data);
        }
      },
      submitSearch (data) {
        const cmp = this;
        let searchData = {};
        searchData['action'] = 'hitlist';
        searchData['filter'] = data.filter;
        searchData['sources'] = data.sources;
        searchData['columns'] = Vue.prototype.storage.currentHeaderFields;
        searchData['mode'] = this.hitlistMode;
        if (!isNaN(data.totalHits)) searchData['totalHits'] = data.totalHits;
        if (searchData['filter'].length == 0) {
          return;
        }
        if (searchData['filter'].length > 1) {
          searchData['formula'] = data.formula;
        }
        Vue.prototype.$api.showIdle();
        Vue.prototype.$api.getHitlist(searchData, this.reqHitlist, function(data) {
          Vue.prototype.$api.hideIdle();
          if (data && data.table && data.table.columns) {
            let columns = [];
            for (const c of data.table.columns) {
              columns.push (c.id);
            }
            cmp.headerFields = columns;
          }
          cmp.OnGetHitListSearch(data);
        }); 
      },

      submitExport () {
        const cmp = this;

        Vue.prototype.$api.showIdle();
        Vue.prototype.$api.getExportInfo(this.hitlistMode, this.currentSearchData, function (data) {
          Vue.prototype.$api.hideIdle();

          if (data.totalHits > 1000000) {
            Vue.prototype.$eventHub.$emit('OnShowError', {
              isDetail: true,
              title: "Trefferliste exportieren",
              message: "Mehr als 1.000.000 Treffer können nicht exportiert werden, da Excel eine Zeilenbegrenzung hat."
            });
          }
          else if (data.totalHits > 10000) {
            cmp.$refs.dlgDoExport.open({
              title: "TITLE_EXPORT_HITLIST",
              description: "QUEST_EXPORT_LARGE_HITLIST",
              countHits: Vue.prototype.$api.formatLocaleNumber('n0', data.totalHits),
              exportCaption: "EXPORT_HITLIST_CAPTION",
              exportType: cmp.hitlistMode,
              searchData: cmp.currentSearchData
            });
          }
          else {
            Vue.prototype.$api.showIdle();
            let searchData = JSON.parse(JSON.stringify(cmp.currentSearchData));
            Vue.prototype.$api.getHitlistDownload(searchData, cmp.hitlistMode, function() { Vue.prototype.$api.hideIdle() });
          }
        }, Vue.prototype.$api.onAjaxFailure);
      },


      onPageChange: function (eventData) {
        console.log ('onPageChange - ' + eventData + " - " +  (typeof this.pageCache[eventData]));
        if (typeof this.pageCache[eventData] === 'object') {
          this.pgresults = this.pageCache[eventData];
          this.openTable();
        } else {
          Vue.prototype.$api.showIdle();
          this.getPageData(eventData, true);
        }
        Vue.prototype.$eventHub.$emit('updatehitlistpager', { page: eventData });
      },

      getPageData: function (pageNum, updateCurrent) {
        var cmp = this;
        this.currentSearchData.action = 'page';
        this.currentSearchData.page = pageNum;

        if (typeof cmp.pageCache[pageNum] === 'string') {
          cmp.pageCache[pageNum] = 'needupdate';
          return;
        }

        cmp.pageCache[pageNum] = 'loading';
        Vue.prototype.$api.sendPostRequest("ajaxGetHitlist.php", this.currentSearchData, null, function(data) {
          var result = Vue.prototype.$api.prepareWaimeaTable(data.table);
          if (cmp.pageCache[pageNum] == 'needupdate') updateCurrent = true;
          cmp.pageCache[pageNum] = result.rows;
          if (updateCurrent) {
            cmp.pgresults = cmp.pageCache[pageNum];
            cmp.openTable();
            Vue.prototype.$api.hideIdle();
          }
        });
      },

      doExport () {
        Vue.prototype.$eventHub.$emit('onExecuteExport');
        this.submitExport();
      },
      openTable: function () {
        var cmp = this
        if (this.$refs.sdTable && this.$refs.sdTable.updateData) {
          this.$refs.sdTable.updateHeader(this.headers)
          if (cmp.first) {
            for (var i = 0;i < this.headers.length; i++) {
              let headItem = this.headers[i]
              // TODO: Standardsortierung ist Unternehmensname, woher bekomme ich die Info welche SpaltenID das ist?
              // if (headItem.meta.id.indexOf('Name') > -1) {
              //   this.orderCellName = i + 1
              //   cmp.first = false
              //   break;
              // }
            }
          }
          console.log('DEBUG sorting by ' + this.orderCellName);
          Vue.prototype.$eventHub.$emit('updatehitlistpager', { page: this.page });
          this.$refs.sdTable.updateData(this.pgresults, true, this.orderCellName);

          // Cache next page
          // if (this.page < this.pageCount) {
          //   // Disabled - SQLDEBUG
          //   //this.getPageData(this.page+1, false);
          // }
        }
      },
      /*
      open: function () {
        if (this.pgresults && this.pgresults.rows) {
          Vue.prototype.$eventHub.$emit('hitlistcounter', {
            hits: this.pgresults.rows.length,
            totalHits: this.myData.totalHits,
            totalHitsAppendix: this.myData.totalHitsAppendix
          })
        } else {
          Vue.prototype.$eventHub.$emit('hitlistcounter', {
            hits: -1,
            totalHits: -1,
            totalHitsAppendix: ''
          })
        }
        this.openTable()
      },
      */
      close: function () {
        if (this.$refs.sdTable && this.$refs.sdTable.doDestroyTable) {
          this.$refs.sdTable.doDestroyTable()
        }
      },

      onGetBalancesHitlist: function (data) {
        Vue.prototype.$api.debug('onGetBalancesHitlist', data);
        if (data.table.rows.length < 1) {
          Vue.prototype.$api.debug('Keine Treffer für crefoNr ' + this.currentCrefoNr);
          let balance = {
            aaNr: '0',
            crefoNr: this.currentCrefoNr,
            rkNr: '0',
            source: '0',
            year: '0'
          };
          Vue.prototype.$api.debug('open balance', balance);

          this.$router.push(Vue.prototype.$api.getStructureAnchorUrl(this.idModule, balance));
          return;
        }
        Vue.prototype.$api.debug('onGetBalancesHitlist', data.table.rows.length, this.currentItem.meta.balanceAvailable);
        // Kein NachschaltDialog anzeigen wenn kein Abschluss vorhanden also wenn -> this.currentItem.meta.balanceAvailable === false
        if ((data.table.rows.length === 1) || (!this.currentItem.meta.balanceAvailable)) {
          let balance = data.table.rows[0].balance;
          Vue.prototype.$api.debug('balance', balance);
          this.$router.push(Vue.prototype.$api.getStructureAnchorUrl(this.idModule, balance));
        } else {
          this.$refs.dialogSelectBalance.show(data);
        }
      },
      onSelectItem: function (item) {
        Vue.prototype.$api.debug('show after dialog for', item);
        this.currentItem = item;
        if (item.meta) {
          if (item.meta.balance) {
            this.currentCrefoNr = item.meta.balance.crefoNr;
          } else {
            this.currentCrefoNr = item.meta.crefoNr;
          }
        }
        Vue.prototype.$api.getBalancesHitlist(this.currentCrefoNr, this.onGetBalancesHitlist);
      },
      OnGetHitListSearch: function (data) {
        Vue.prototype.$api.debug('OnGetHitListSearch', data);
        this.currentSearchData = data.searchData;

        data.info = [];
        if (data.execTimePerformSql) data.info['time'] = data.execTimePerformSql;
        if (data.query) data.info['sql'] = data.query;
        if (data.totalHits && data.totalHits > 0) {
          this.canExport = true;
          Vue.prototype.$eventHub.$emit('updatehitlistpager', {
            info: data.info,
            totalHits: +data.totalHits,
            hitsPerPage: +data.hitsPerPage,
            page: 1
          });
        } else {
          this.canExport = false;
          Vue.prototype.$eventHub.$emit('updatehitlistpager', {
            info: data.info,
            totalHits: 0,
            hitsPerPage: 0,
            page: 0
          });
        }

        this.headers = [];
        this.pageCache = [];
        var result = Vue.prototype.$api.prepareWaimeaTable(data.table);
        this.headers = result.headers;
        this.pageCache[this.page] = result.rows;
        this.pgresults = this.pageCache[this.page];

        Vue.prototype.storage.saveState('LastHitList_' + this.target, data)
        this.openTable();
      },
      onHitlistConfigChange: function (action, param1, param2) {
        const cmp = this;

        // reset the hitlist to the global default values
        if (action == 'reset') {
          Vue.prototype.$api.setHitlistConfiguration(this.hitlistMode, '', [], function (data) {
            Vue.prototype.storage.currentHeaderFields = data;
            Vue.prototype.$api.showIdle();
            cmp.onHitlistConfigChange('reload');
          });
          return;
        }

        // load a named hitlist configuration
        //   param1 - name of the hitlist configuration to load
        if (action == 'load') {
          Vue.prototype.$api.getHitlistConfiguration(this.hitlistMode, param1, function (data)  {
            Vue.prototype.storage.currentHeaderFields = data;
            Vue.prototype.$api.showIdle();
            cmp.onHitlistConfigChange('reload');
          })
        }

        // save the current hitlist configuration
        //   param1 - name of the new hitlist configuration 
        if (action == 'save') {
          Vue.prototype.$api.setHitlistConfiguration(cmp.hitlistMode, param1, Vue.prototype.storage.currentHeaderFields, function (data) {
            Vue.prototype.$api.getHitlistConfigurations(cmp.hitlistMode, function (data) {
              cmp.hitlistConfigurations = data;
            });
          });
          return;
        }

        // delete a named hitlist configuration
        //   param1 - name of the hitlist configuration to delete
        if (action == 'delete') {
          Vue.prototype.$api.setHitlistConfiguration(this.hitlistMode, param1, [], function (data) {
            Vue.prototype.$api.getHitlistConfigurations(cmp.hitlistMode, function (data) {
              cmp.hitlistConfigurations = data;
            });
          });
          return;
        }


        // move a hitlist column
        //   param1 - fieldId of the field beeing moved
        //   param2 - index of the field used for dropping (counting from 1)
        if (action == 'move') {
          Vue.prototype.$api.debug("current header fields", {headers: cmp.headers, currentHeaderFields: Vue.prototype.storage.currentHeaderFields});

          const srcindex = cmp.headers.findIndex(function (item, index) { return item.meta.id == param1; });
          if (srcindex == -1) {
            // We are dropping a new field from the SearchItemManager
            cmp.onHitlistConfigChange('add', param1, param2);
            return;
          }
          let dstindex = param2 ? param2 - 1 : cmp.headers.length;

          // if we are moving to the left insert before/at dstindex, if moving to the right insert after dstindex
          // TODO: Check if this is useful. Alternative: only insert after dstindex if moving one to the right (dst == src+1)
          //if (srcindex <= dstindex) dstindex++;
          if (srcindex+1 == dstindex) dstindex++;

          // If we are moving an extraField, add it to the fieldlist
          if (cmp.headers[srcindex].isExtraField === true)
            cmp.headers[srcindex].isExtraField = false;

          // adjust the table
          let nh = [];
          let nhf = [];
          for (const i in cmp.headers) {
            if (i == dstindex) { 
              nh.push(cmp.headers[srcindex]);
              if (cmp.headers[srcindex].isExtraField !== true) {
                nhf.push(cmp.headers[srcindex].meta.id);
              }
            }
            if (i == srcindex) continue;
            nh.push(cmp.headers[i]);
            if (cmp.headers[i].isExtraField !== true) {
              nhf.push(cmp.headers[i].meta.id);
            }
          }
          if (dstindex >= cmp.headers.length) {
              nh.push(cmp.headers[srcindex]);
              if (cmp.headers[srcindex].isExtraField !== true) {
                nhf.push(cmp.headers[srcindex].meta.id);
              }
          }
          cmp.headers = nh;
          Vue.prototype.storage.currentHeaderFields = nhf;
          Vue.prototype.$api.setHitlistConfiguration(this.hitlistMode, "", Vue.prototype.storage.currentHeaderFields);
          Vue.prototype.$api.debug("Setting new header fields", {headers: nh, currentHeaderFields: nhf});
          return;
        }

        // Add a new column to the hitlist
        //   param1 - fieldId of the field beeing added
        //   param2 - (optional) index where the field should be inserted (of the field used for dropping (counting from 1)
        if (action == 'add') {
          if (cmp.headers.findIndex(function (item, index) { return item.meta.id == param1; }) != -1) {
            // Noop if the column is alreeady there
            return;
          }
          if ((param2 !== undefined) && ((param2-1) < cmp.headers.length) && (cmp.headers[param2-1].isExtraField == false)) {
            let inspos = Vue.prototype.storage.currentHeaderFields.findIndex(function (item, index) { return item === cmp.headers[param2-1].meta.id; });
            if (inspos == -1) {
              Vue.prototype.storage.currentHeaderFields.push(param1);
            }
            else {
              let nhf = [];
              for (const i in Vue.prototype.storage.currentHeaderFields) {
                if (i == inspos) nhf.push(param1);
                nhf.push(Vue.prototype.storage.currentHeaderFields[i]);
              }
            }
          }
          else {
            Vue.prototype.storage.currentHeaderFields.push(param1);
          }
          Vue.prototype.$api.setHitlistConfiguration(this.hitlistMode, "", Vue.prototype.storage.currentHeaderFields);
          Vue.prototype.$api.getFilterInfo(param1, function (data) {
            let newCol = {};
            newCol.id = data.id;
            newCol.text = data.title;
            newCol.meta = {};
            newCol.meta.id = data.id;
            newCol.isExtraField = false;
            newCol.meta.headerAlign = 'L';
            newCol.meta.width = data.title.length + 2;
            newCol.meta.type = 'spare';

            let nh = [];
            let inspos = Vue.prototype.storage.currentHeaderFields.length - 2;
            if ((param2 !== undefined) && ((param2-1) < cmp.headers.length)) {
              inspos = param2-1;
            }
            for (const i in cmp.headers) {
              nh.push(cmp.headers[i]);
              if (i == inspos) nh.push(newCol);
            }
            if (inspos >= cmp.headers.length) nh.push(newCol);
            cmp.headers = nh;

            // Trigger reload of current hitlist page
            Vue.prototype.$eventHub.$emit('HitlistConfigChange', 'reload');
          });
          return;
        }

        // remove a hitlist column
        //   param1 - fieldId of the field beeing removed
        if (action == 'remove') {
          let index = -1;
          if ((index = Vue.prototype.storage.currentHeaderFields.findIndex(function (item, index) { return item === param1; })) > -1) {
            Vue.prototype.storage.currentHeaderFields.splice(index, 1);
            Vue.prototype.$api.setHitlistConfiguration(this.hitlistMode, "", Vue.prototype.storage.currentHeaderFields);
          }
          if ((index = cmp.headers.findIndex(function (item, index) { return item.meta.id == param1; })) > -1) {
            cmp.headers.splice(index, 1);
          }
          return;
        }

        // Reload hitlist
        if (action == 'reload') {
          this.currentSearchData['columns'] = Vue.prototype.storage.currentHeaderFields;
          //Vue.prototype.$api.showIdle();
          Vue.prototype.$api.getHitlist(this.currentSearchData, this.reqHitlist, function(data) {
            Vue.prototype.$api.hideIdle();
            if (data && data.table && data.table.columns) {
              let columns = [];
              for (const c of data.table.columns) {
                columns.push (c.id);
              }
              cmp.headerFields = columns;
            }
            cmp.OnGetHitListSearch(data);
          });
          return;
        }
      },
    },
    created() {
      Vue.prototype.$eventHub.$on('OnGetHitListSearch', this.OnGetHitListSearch)
      Vue.prototype.$eventHub.$on('ETClickOnRow', this.onSelectItem)
      Vue.prototype.$eventHub.$on('PageChange', this.onPageChange);
      Vue.prototype.$eventHub.$on('SearchRulesEditRule', this.onSearchRulesEditRule);
      Vue.prototype.$eventHub.$on('SearchRulesManagerAction', this.onSearchRulesManagerAction);
      Vue.prototype.$eventHub.$on('HitlistConfigChange', this.onHitlistConfigChange);
      window.addEventListener("resize", this.onResize);
    },
    destroyed() {
      Vue.prototype.$eventHub.$off('OnGetHitListSearch', this.OnGetHitListSearch)
      Vue.prototype.$eventHub.$off('ETClickOnRow', this.onSelectItem)
      Vue.prototype.$eventHub.$off('PageChange', this.onPageChange);
      Vue.prototype.$eventHub.$off('SearchRulesEditRule', this.onSearchRulesEditRule);
      Vue.prototype.$eventHub.$off('SearchRulesManagerAction', this.onSearchRulesManagerAction);
      Vue.prototype.$eventHub.$off('HitlistConfigChange', this.onHitlistConfigChange);
      window.removeEventListener("resize", this.onResize);
    },
    mounted() {
      const cmp = this;
      this.first = true;

      this.setSearchMode(true);

      Vue.prototype.$eventHub.$emit('updatehitlistpager', {
        hits: -1,
        totalHits: -1,
      });
      Vue.prototype.$api.getHitlistConfigurations(this.hitlistMode, function (data) {
        cmp.hitlistConfigurations = data;
      });
      Vue.prototype.$api.getHitlistConfiguration(this.hitlistMode, "", function (data) {
        Vue.prototype.$api.debug('onGetHitListConfig', data);
        cmp.headerFields = data;
        Vue.prototype.storage.currentHeaderFields = data;
      });
      this.currencyDimensions = [];
      this.currencyDimensions.push({id: 1, name: "€"})
      for (let i = 2; i <= 3; i++) {
        let dimension = Vue.prototype.$api.getI18NCurrencyDimension(i);
        this.currencyDimensions.push({id: dimension.id, name: dimension.name + " €"})
      }

      Vue.prototype.$api.checkCredentials(cmp, function () {
       
        Vue.prototype.storage.resetPeergroup(Vue.prototype.$api.getModuleId())
        Vue.prototype.storage.resetAnkerbank(Vue.prototype.$api.getModuleId())
        if (cmp.$route.params) {
          cmp.idModule = cmp.$route.params.idModule
          cmp.idModuleItem = cmp.$route.params.idModuleItem
        }

        cmp.target = cmp.idModule + '_' + cmp.hitlistMode;
        Vue.prototype.$api.debug('target', cmp.target);
        let data = Vue.prototype.storage.getState('LastHitList_' + cmp.target);
        if (data) {
          cmp.OnGetHitListSearch(data);
        }

        Vue.prototype.$api.getBreadCrumpModule(cmp.idModule)
        cmp.firstOrderBy = cmp.idModule + 'Name'
        cmp.link = '/di/StructureData/' + cmp.idModule

        cmp.$nextTick(function () {
          window.dispatchEvent(new Event('resize'));
        });

      });
    }
  }
</script>

<style>
.v-tabs__item--active {
  background-color: gainsboro;
}
</style>



// WEBPACK FOOTER //
// src/components/module/Suche.vue